// src/utils/constants.ts

export const ROLES = [
  'Season Admin',
  'Season Manager', 
  'Fixture Manager',
  'Role Manager',
  'Support Observer'
] as const;

export const FIXED_ORG_ID = 'k11s0';

export const PERMISSION_STATUS = {
  ACTIVE: 'active',
  TODO: 'to-do',
  INACTIVE: 'inactive'
} as const;

export const ORGANIZATIONS = [
  { id: 'k11s0', name: 'International Hockey Federation' },
  { id: 'k1rd3', name: 'South African Hockey Association' },
  { id: 'k10x2', name: 'Ghana Hockey Association' },
  { id: 'k14fk', name: 'Bermuda Hockey Federation' },
  { id: 'k18jp', name: 'Norwegian Bandy Association' },
  { id: 'k1as0', name: 'Hockey Association Malta' },
  { id: 'k1vqj', name: 'Oman Hockey Association' },
  { id: 'k1t0k', name: 'Gibraltar Hockey' },
  { id: 'k146d', name: 'Barbados Hockey Federation' }
];